module.exports = __webpack_public_path__ + "7b0eae6c24d81bcbe91585d429ebff7e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/header/user-default-avt.png
// module id = ./assets/images/header/user-default-avt.png
// module chunks = 0